module.exports = __webpack_public_path__ + "img/public/SiteIcons/currencyIcon.svg?c9c31852";